import { Flex, Label } from "@jsq/ds/core";
import { FormCheckbox, FormPercentInput, useFormContext } from "@jsq/ds/forms";
import RoleInfoBox from "../../../../common/RoleInfoBox";
import { roleFieldsRow } from "../styles_vanilla.css";
import { FormValues } from "../types";

const ProfileEntityFormFields = ({
  isOnboardingCase = false,
}: {
  isOnboardingCase?: boolean;
}) => {
  const { values } = useFormContext<FormValues>();

  return (
    <>
      <Flex justifyContent="space-between" flexDirection="row" className={roleFieldsRow}>
        <Flex flexDirection="column" alignItems="flex-start">
          <Label>{isOnboardingCase ? "Role" : "Role(s)"}</Label>
          <FormCheckbox name="isOwner" label="Owner"></FormCheckbox>
          <FormCheckbox name="isController" label="Controller"></FormCheckbox>
        </Flex>
        {values.isOwner === true && (
          <FormPercentInput label="Ownership percentage" name="ownershipPercentage" />
        )}
      </Flex>
      <RoleInfoBox />
    </>
  );
};
export default ProfileEntityFormFields;
